module.exports = __webpack_public_path__ + "img/wallet.c6b235aa.svg";